import { useCallback } from "react";
import api, { openApi } from "../../services/api";

const useSettings = () => {
  const getAll = useCallback(async (params) => {
    try {
      const { data } = await api.request({
        url: "/settings",
        method: "GET",
        params,
      });
      return Array.isArray(data) ? data : (data?.settings || []);
    } catch (error) {
      console.warn('Failed to get settings:', error);
      return [];
    }
  }, []);

  const update = useCallback(async (data) => {
    const { data: responseData } = await api.request({
      url: `/settings/${data.key}`,
      method: "PUT",
      data,
    });
    console.log(responseData);
    return responseData;
  }, []);

  const get = useCallback(async (param) => {
    const { data } = await api.request({
      url: `/setting/${param}`,
      method: "GET",
    });
    return data;
  }, []);

  const getPublicSetting = useCallback(async (key, companyId = null) => {
    try {
      const params = companyId ? { companyId } : {};
      const { data } = await openApi.request({
        url: `/public-settings/${key}`,
        method: "GET",
        params,
      });
      return data || null;
    } catch (error) {
      console.warn(`Failed to get public setting '${key}':`, error);
      return null;
    }
  }, []);

  return {
    getAll,
    update,
    get,
    getPublicSetting,
  };
};

export default useSettings;
